
import styled from 'styled-components';

const StyledAppWrapper = styled.div.attrs(({ $size = {} }) => ({
  style: {
    width: $size.width ?? '100%',
    height: $size.height ?? '100%',
  },
}))`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
  background: ${({ theme }) => theme.palette['bg-secondary']};
`;

const StyledMainContent = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;

  [data-phone='true'] & {
    padding: 0;
  }
`;

const StyledCanvasAndTools = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const StyledPhoneToolsAndTabs = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export {
  StyledAppWrapper,
  StyledMainContent,
  StyledCanvasAndTools,
  StyledPhoneToolsAndTabs,
};
